export const RAID = 'raid';
export const MECH_ARENA = 'mechArena';